import { cn } from '@ais-ui/utils';

/**
 * Tailwind classes for a small status dot reflecting an arrival/candidate
 * probability: green (high), yellow (medium), red (low), gray (unknown).
 * Shared between the vessel-centric next-port panel and the port-centric
 * arrival predictions list so the color scale stays consistent.
 */
export const probabilityDotClass = (probability: number | undefined) =>
  cn(
    'block size-2 shrink-0 rounded-full',
    (probability ?? -1) === -1 && 'bg-muted-foreground',
    (probability ?? -1) >= 0.5 && 'bg-green-500',
    (probability ?? -1) < 0.5 && (probability ?? -1) > 0.2 && 'bg-yellow-500',
    (probability ?? -1) <= 0.2 && 'bg-red-500',
  );

export const formatProbability = (probability: number | undefined) =>
  probability ? `${(probability * 100).toFixed(1)} %` : '-';
